import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import './Bookshelf.css';

import { Text } from "@geist-ui/core";
import { saveLastBook } from '../../../utils/storyUtils';
import { trackBookInteraction } from '../../../config/analytics';
import { getAssetUrl } from '../../../utils/assetUtils';

const BookItem = ({ id, title, tier, cover, bookdata, author, genre }) => {
  const navigate = useNavigate();
  const [imageSrc, setImageSrc] = useState(getAssetUrl(cover, { forceWebP: true }));

  const handleBookClick = () => {
    if (bookdata) {
      const bookInfo = { id, title, tier, cover, bookdata, author, genre };
      saveLastBook(bookInfo);
      trackBookInteraction('Open', id);
      navigate(`/story/${id}`, { state: bookInfo });
    }
  };

  const handleImageError = () => {
    console.error("Failed to load book cover image:", cover);
    setImageSrc(getAssetUrl(cover, { forceWebP: false }));
  };

  return (
    <div className={`book ${!bookdata ? 'non-clickable' : ''}`} onClick={handleBookClick}>
      <div className="book-cover-wrapper">
        <img 
          src={imageSrc} 
          alt={title} 
          className="book-cover" 
          onError={handleImageError}
        />
        <div className="book-pages"></div>
      </div>
      <Text h3>{title}</Text> 
      <Text h6>by {author}</Text> 
      
      <div className="book-tags">
        <div className={`tag book-tier-${tier.toLowerCase().replace(' ', '-')}`}><Text span>{tier}</Text></div>
        {genre && <div className="tag"><Text span>{genre}</Text></div>}
      </div>
    </div>
  );
};

BookItem.propTypes = {
    id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tier: PropTypes.string.isRequired,
  cover: PropTypes.string.isRequired,
  bookdata: PropTypes.string,
  author: PropTypes.string.isRequired,
  genre: PropTypes.string, // Add genre prop type
};

const BookshelfPage = () => {
  const allBooks = [
    { 
      category: "Solo Adventures",
      books: [
        { 
          id: "wolves_of_langston",
          title: "The Wolves of Langston", 
          tier: "Tier 1", 
          cover: "/assets/wolves.png", 
          bookdata: "@assets/books/wolves_of_langston/data/wolves_of_langston.json",
          author: "Daniel Howard",
          genre: "Murder Mystery" 
        },
        { 
          id: "crystals",
          title: "The Crystals of Z'leth", 
          tier: "Coming Soon", 
          cover: "/assets/covers/crystals.png", 
          bookdata: "",
          author: "Daniel Howard",
          genre: "Dungeon Crawl" 
        },
        { 
          id: 3, 
          title: "The Secret of Oki Island", 
          tier: "Coming Soon", 
          cover: "/assets/covers/oki.png", 
          bookdata: "",
          author: "HL Truslove",
          genre: "Treasure Hunt" 
        },
      ]
    },
    {
      category: "Sidequests",
      books: [
        { 
          id: "pantry",
          title: "The Pantry", 
          tier: "Tier 1", 
          bookdata: "@assets/books/pantry/data/pantry.json",
          cover: "/assets/covers/pantry.png",
          author: "Kai Wloka",
          genre: "Horror" 
        },
       { 
          id: "ser_laurens_cursed_cycle",
          title: "Ser Lauren's Cursed Cycle", 
          tier: "Tier 1", 
          bookdata: "@assets/books/pantry/data/ser_laurens_cursed_cycle.json",
          cover: "/assets/covers/ser_lauren.png",
          author: "Deborah D'Antonio L.B. Almeida",
          genre: "Dark Fantasy" 
        },
        { 
          id: "gritz_manor",
          title: "Gritz Manor", 
          tier: "Tier 1", 
          bookdata: "@assets/books/auction_at_gritz_manor/data/gritz_manor.json",
          cover: "/assets/covers/gritz.png",
          author: "Deborah D'Antonio L.B. Almeida",
          genre: "Mystery" 
        }
      ]
    }
  ];

  return (
    <div className="bookshelf-page">
      <div className="bookshelf-container">
        {allBooks.map(section => (
          <div key={section.category} className="category-section">
            <Text h2>{section.category}</Text> 

            <div className="books-grid">
              {section.books.map(book => (
                <BookItem key={book.id} {...book} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookshelfPage;
